import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export default Axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const axiosPrivate = Axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
